export default __webpack_public_path__ + "static/media/plane-right.e782b289.png";